export default "__VITE_ASSET__7219a3c3__"